"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[855],{

/***/ 459949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U": function() { return /* reexport */ FeatureFlagIt; }
});

// EXTERNAL MODULE: ./src/components/FeatureFlagsProvider/index.ts + 3 modules
var FeatureFlagsProvider = __webpack_require__(96505);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(135944);
;// CONCATENATED MODULE: ./src/components/FeatureFlagIt/FeatureFlagIt.tsx



var FeatureFlagIt = function FeatureFlagIt(_ref) {
  var id = _ref.id,
      children = _ref.children;
  var featureFlags = (0,FeatureFlagsProvider/* useFeatureFlags */.g)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: featureFlags[id] && children
  });
};
;// CONCATENATED MODULE: ./src/components/FeatureFlagIt/index.ts


/***/ }),

/***/ 372855:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "IE": function() { return /* binding */ BaseLayout; },
  "eE": function() { return /* binding */ NAV_BAR_WIDTH; }
});

// UNUSED EXPORTS: PAGES, isButtonActive

// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(370917);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js
var emotion_element_6a883da9_browser_esm = __webpack_require__(152443);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(217674);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/@mui/material/Avatar/Avatar.js + 1 modules
var Avatar = __webpack_require__(487952);
// EXTERNAL MODULE: ./node_modules/@mui/material/Menu/Menu.js
var Menu = __webpack_require__(424486);
// EXTERNAL MODULE: ./node_modules/@mui/material/MenuItem/MenuItem.js
var MenuItem = __webpack_require__(863931);
// EXTERNAL MODULE: ./node_modules/@mui/material/Divider/Divider.js
var Divider = __webpack_require__(467720);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Person.js
var Person = __webpack_require__(815398);
// EXTERNAL MODULE: ./src/shared-components/PUITooltip/PUITooltip.tsx + 1 modules
var PUITooltip = __webpack_require__(566538);
// EXTERNAL MODULE: ./src/shared-components/PUIIconButton/index.ts + 1 modules
var PUIIconButton = __webpack_require__(376901);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(135944);
;// CONCATENATED MODULE: ./src/components/AccountSettingsMenu/AccountSettingsMenu.tsx









var getUserInitials = function getUserInitials(user) {
  var _user$company_key, _user$user_email;

  if (!user) return null;
  return [(_user$company_key = user.company_key) === null || _user$company_key === void 0 ? void 0 : _user$company_key.charAt(0).toUpperCase(), (_user$user_email = user.user_email) === null || _user$user_email === void 0 ? void 0 : _user$user_email.charAt(0).toUpperCase()].filter(function (elem) {
    return typeof elem === 'string';
  })[0];
};
var AccountSettingsMenu = function AccountSettingsMenu(_ref) {
  var _ref2;

  var userIdentity = _ref.userIdentity,
      logout = _ref.onLogout;

  var _React$useState = react.useState(null),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      anchorEl = _React$useState2[0],
      setAnchorEl = _React$useState2[1];

  var open = Boolean(anchorEl);

  var handleClick = function handleClick(event) {
    setAnchorEl(event.currentTarget);
  };

  var handleClose = function handleClose() {
    setAnchorEl(null);
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PUITooltip/* PUITooltip */.p, {
      title: "Account settings",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PUIIconButton/* PUIIconButton */.X, {
        onClick: handleClick,
        size: "small",
        "aria-controls": open ? 'account-menu' : undefined,
        "aria-haspopup": "true",
        "aria-expanded": open ? 'true' : undefined,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Avatar/* default */.Z, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Person/* default */.Z, {})
        })
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Menu/* default */.Z, {
      anchorEl: anchorEl,
      id: "account-menu",
      open: open,
      onClose: handleClose,
      onClick: handleClose,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuItem/* default */.Z, {
        disabled: true,
        children: (_ref2 = (userIdentity === null || userIdentity === void 0 ? void 0 : userIdentity.user_email) || (userIdentity === null || userIdentity === void 0 ? void 0 : userIdentity.company_key)) !== null && _ref2 !== void 0 ? _ref2 : 'Unknown Company'
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuItem/* default */.Z, {
        onClick: logout,
        children: "Logout"
      })]
    })]
  });
};
;// CONCATENATED MODULE: ./src/components/AccountSettingsMenu/index.ts

// EXTERNAL MODULE: ./src/components/ApiClientProvider/index.ts + 6 modules
var ApiClientProvider = __webpack_require__(619812);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(811163);
// EXTERNAL MODULE: ./src/shared-components/index.ts + 30 modules
var shared_components = __webpack_require__(175466);
// EXTERNAL MODULE: ./src/shared-components/PUINavBar/index.ts + 2 modules
var PUINavBar = __webpack_require__(812627);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/QueryStats.js
var QueryStats = __webpack_require__(74682);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/BatchPrediction.js
var BatchPrediction = __webpack_require__(15028);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Tune.js
var Tune = __webpack_require__(875395);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/SsidChart.js
var SsidChart = __webpack_require__(275086);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Send.js
var Send = __webpack_require__(726307);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Attractions.js
var Attractions = __webpack_require__(93289);
// EXTERNAL MODULE: ./src/components/PageTitle/index.ts + 1 modules
var PageTitle = __webpack_require__(327743);
// EXTERNAL MODULE: ./src/components/FeatureFlagIt/index.ts + 1 modules
var FeatureFlagIt = __webpack_require__(459949);
;// CONCATENATED MODULE: ./src/pages/layouts/BaseLayoutWithSideNav.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }














var NAV_BAR_WIDTH = '5rem';
var PAGES;

(function (PAGES) {
  PAGES["HOME"] = "/";
  PAGES["BATCH_PRICING"] = "/batch-pricing";
  PAGES["BID_CONFIGURATION"] = "/bid-configuration";
  PAGES["BID_ANALYTICS"] = "/bid-analytics";
  PAGES["CODRIVER"] = "/codriver";
  PAGES["REPORTING_SANDBOX"] = "/reporting-sandbox";
})(PAGES || (PAGES = {}));

var sideNavBarToolbarsWrapperStyle = {
  flex: '1 1',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  width: '100%'
};
function isButtonActive(buttonPath) {
  return RegExp(buttonPath).exec(location.pathname) ? 'active' : '';
}

var _ref2 =  true ? {
  name: "zjik7",
  styles: "display:flex"
} : 0;

var BaseLayout = function BaseLayout(_ref) {
  var children = _ref.children,
      aside = _ref.aside,
      title = _ref.title;
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  var router = (0,next_router.useRouter)();

  var _useApiClient = (0,ApiClientProvider/* useApiClient */.mb)(),
      _useApiClient$session = _useApiClient.session,
      userIdentity = _useApiClient$session.user.identity,
      logout = _useApiClient$session.logout;

  var logoutHandler = (0,react.useCallback)(function () {
    return logout(false);
  }, [logout]);
  var buildPageClickHandler = (0,react.useCallback)(function (route) {
    return function () {
      router.push(route)["catch"](function (error) {
        console.error(error);
      });
    };
  }, [router]);
  var sideNavToolbarStyle = {
    flexDirection: 'column',
    padding: "".concat(theme.spacing(3), " 0")
  };
  var sideNavActiveButtonStyle = {
    '&.active': {
      backgroundColor: theme.palette.neutral.dark,
      borderRadius: '5%'
    }
  };
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PageTitle/* PageTitle */.V, {
      optionalTitle: title
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      css: _ref2,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PUINavBar/* PUINavBar */.V, {
        color: "secondary",
        position: "fixed",
        vertical: true,
        toolbarContent: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PUINavBar/* PUIToolbar */._, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(shared_components.PUIIconButton, {
              onClick: buildPageClickHandler(PAGES.HOME),
              size: "large",
              color: "inherit",
              "aria-label": "Main",
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(shared_components.PUIParadeLogo, {
                size: "small"
              })
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(shared_components.PUIDivider, {
            orientation: 'horizontal',
            flexItem: true
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: sideNavBarToolbarsWrapperStyle,
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PUINavBar/* PUIToolbar */._, {
              css: sideNavToolbarStyle,
              disableGutters: true,
              role: "navigation",
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(shared_components.PUITooltip, {
                title: "Lane Search",
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(shared_components.PUIIconButton, {
                  onClick: buildPageClickHandler(PAGES.HOME),
                  size: "large",
                  color: "inherit",
                  css: sideNavActiveButtonStyle,
                  className: isButtonActive('(^/$)|(/advantage)'),
                  "aria-label": "Advantage Dashboard",
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(QueryStats/* default */.Z, {
                    height: 36,
                    width: 36
                  })
                })
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(shared_components.PUITooltip, {
                title: "Batch Price Prediction",
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(shared_components.PUIIconButton, {
                  onClick: buildPageClickHandler(PAGES.BATCH_PRICING),
                  size: "large",
                  color: "inherit",
                  css: sideNavActiveButtonStyle,
                  className: isButtonActive(PAGES.BATCH_PRICING),
                  "aria-label": "Batch Pricing",
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BatchPrediction/* default */.Z, {
                    height: 36,
                    width: 36
                  })
                })
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureFlagIt/* FeatureFlagIt */.U, {
                id: "show-real-time-rating-rules-configuration",
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(shared_components.PUITooltip, {
                  title: "Real Time Rating Configuration",
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(shared_components.PUIIconButton, {
                    onClick: buildPageClickHandler(PAGES.BID_CONFIGURATION),
                    size: "large",
                    color: "inherit",
                    css: sideNavActiveButtonStyle,
                    className: isButtonActive(PAGES.BID_CONFIGURATION),
                    "aria-label": "Real Time Rating Configuration",
                    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tune/* default */.Z, {
                      height: 36,
                      width: 36
                    })
                  })
                })
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureFlagIt/* FeatureFlagIt */.U, {
                id: "show-real-time-rating-rules-analytics",
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(shared_components.PUITooltip, {
                  title: "Bid Analytics",
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(shared_components.PUIIconButton, {
                    onClick: buildPageClickHandler(PAGES.BID_ANALYTICS),
                    size: "large",
                    color: "inherit",
                    css: sideNavActiveButtonStyle,
                    className: isButtonActive(PAGES.BID_ANALYTICS),
                    "aria-label": "Bid Analytics",
                    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SsidChart/* default */.Z, {
                      height: 36,
                      width: 36
                    })
                  })
                })
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureFlagIt/* FeatureFlagIt */.U, {
                id: "show-codriver",
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(shared_components.PUITooltip, {
                  title: "CoDriver Opportunities",
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(shared_components.PUIIconButton, {
                    onClick: buildPageClickHandler(PAGES.CODRIVER),
                    size: "large",
                    color: "inherit",
                    css: sideNavActiveButtonStyle,
                    className: isButtonActive(PAGES.CODRIVER),
                    "aria-label": "CoDriver Opportunities",
                    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Send/* default */.Z, {
                      height: 36,
                      width: 36
                    })
                  })
                })
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(shared_components.PUITooltip, {
                title: "Reporting Sandbox",
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(shared_components.PUIIconButton, {
                  onClick: buildPageClickHandler(PAGES.REPORTING_SANDBOX),
                  size: "large",
                  color: "inherit",
                  css: sideNavActiveButtonStyle,
                  className: isButtonActive(PAGES.REPORTING_SANDBOX),
                  "aria-label": "Reporting Sandbox",
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Attractions/* default */.Z, {
                    height: 36,
                    width: 36
                  })
                })
              })]
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(shared_components.PUIDivider, {
                orientation: 'horizontal',
                flexItem: true
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PUINavBar/* PUIToolbar */._, {
                css: sideNavToolbarStyle,
                disableGutters: true,
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccountSettingsMenu, {
                  userIdentity: userIdentity,
                  onLogout: logoutHandler
                })
              })]
            })]
          })]
        }),
        css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)({
          width: NAV_BAR_WIDTH,
          height: '100vh',
          left: 0,
          alignItems: 'center',
          zIndex: 1250
        },  true ? "" : 0,  true ? "" : 0)
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)({
          width: '100%',
          paddingLeft: NAV_BAR_WIDTH
        },  true ? "" : 0,  true ? "" : 0),
        children: children
      }), aside]
    })]
  });
};

/***/ })

}]);